/* 
  触发：Reflect.emit('${router.path}')
  监听：Reflect.on(()=>{
    })
*/
class Mirror {
  constructor() {
    this.event = [];
  }
  emit(key, param = null) {
    if (!key) return;
    localStorage.setItem(`NOTIFY_${key.toUpperCase()}`, JSON.stringify(param));
    if (this.event.length) {
      this.event.forEach((item) => {
        if (item.key === key) {
          item.callback(key, param);
        }
      });
    }
  }
  watch(keys, callback) {
    if (!callback || !keys) return;
    if (Array.isArray(keys)) {
      keys.forEach((item) => {
        this.event.push({
          key: item,
          callback,
        });
      });
    } else {
      this.event.push({
        key: keys,
        callback,
      });
    }
  }
  once(key, callback) {
    console.log("once");
    if (!callback || !key) return;

    if (Array.isArray(key)) {
      key.forEach((item) => {
        let _key = `NOTIFY_${item.toUpperCase()}`;
        if (localStorage.getItem(_key)) {
          execute(key, _key);
        }
      });
    } else {
      let _key = `NOTIFY_${key.toUpperCase()}`;
      if (localStorage.getItem(_key)) {
        execute(key, _key);
      }
    }
    function execute(key, key2) {
      try {
        callback(key, JSON.parse(localStorage.getItem(key2)));
      } catch (e) {
        console.log(e);
        callback(key, localStorage.getItem(key2));
      }
      localStorage.removeItem(key2);
    }
  }
  delete(key) {
    if (!key) return;
    if (Array.isArray(key)) {
      key.forEach((item) => {
        let _key = `NOTIFY_${item.toUpperCase()}`;
        localStorage.removeItem(_key);
      });
    } else {
      let _key = `NOTIFY_${key.toUpperCase()}`;
      localStorage.removeItem(_key);
    }
  }
}

export default new Mirror();
